@if (bildData) {
  <clr-modal
    [(clrModalOpen)]="showBildModal"
    [clrModalSize]="'lg'"
    class="customModal"
    [clrModalClosable]="true"
    [clrModalStaticBackdrop]="false">
    <div class="modal-body">
      <img class="modalImage" [src]="bildData" />
    </div>
  </clr-modal>
}

<header class="header-2" data-test-id="fat-pruefung-header">
  <div class="branding">
    <span class="title" data-test-id="fat-pruefung-header-title">
      {{ 'do Factory Acceptance Test [FAT]' | mrTranslate }}
    </span>
  </div>
  <div class="header-actions">
    <a href="javascript://" class="nav-link nav-icon" data-test-id="fat-save">
      <cds-icon shape="floppy" (click)="sendForFormulare()" />
    </a>
    <a href="javascript://" class="nav-link nav-icon" data-test-id="fat-close">
      <cds-icon shape="times" (click)="close()" />
    </a>
  </div>
</header>

<div #widthRef class="overlay-inner-wrapper">
  <div id="datenTabs">
    <clr-tabs>
      <clr-tab>
        <button
          clrTabLink
          (click)="tabChange()"
          [title]="'Formularerstellung' | mrTranslate"
          data-test-id="fat-pruefung-tab-main">
          {{ vorlagename | mrTranslate | titlecase }}
        </button>
        <clr-tab-content *clrIfActive>
          <div id="formularerstellungsWrapper" class="fat-scroll-container">
            <div class="clr-row">
              <div class="clr-col-3">
                <button class="btn btn-sm" (click)="triggerLock()" data-test-id="fat-pruefung-lock-toggle">
                  <cds-icon [shape]="locked ? 'lock' : 'unlock'" />
                </button>
              </div>
              <div class="clr-col-7">
                @if (formReflectData.length > 0) {
                  <form clrForm class="clr-form clr-form-horizontal">
                    @for (reflectData of formReflectData; track reflectData) {
                      @if (reflectData.mainTitle) {
                        <h1 id="mainTitle">{{ reflectData.mainTitle }}</h1>
                      }
                      @if (reflectData.title) {
                        <h4 id="title">{{ reflectData.title }}</h4>
                      }
                      @if (reflectData.subheading) {
                        @if (reflectData.fieldType === 'text') {
                          <div class="objektTyp1">
                            <div class="comboboxcontainer clr-form-control clr-row">
                              @if (reflectData.subheading) {
                                <label class="clr-col-md-4 clr-control-label" id="subheading">
                                  {{ reflectData.subheading }}
                                </label>
                              }
                              <div class="clr-control-container clr-col-md-8">
                                <input
                                  clrInput
                                  style="width: 300px"
                                  type="text"
                                  [(ngModel)]="reflectData.value"
                                  [ngModelOptions]="{ standalone: true }"
                                  [readonly]="locked"
                                  data-test-id="fat-pruefung-text-input" />
                              </div>
                            </div>
                          </div>
                        }
                        @if (reflectData.fieldType === 'dropdown') {
                          <div class="objektTyp2">
                            <div class="comboboxcontainer clr-form-control clr-row">
                              @if (reflectData.subheading) {
                                <label class="clr-col-md-4 clr-control-label" id="subheading">
                                  {{ reflectData.subheading }}
                                </label>
                              }
                              <div class="clr-control-container clr-col-md-8">
                                <input
                                  clrInput
                                  style="width: 300px"
                                  type="number"
                                  min="0"
                                  [(ngModel)]="reflectData.value"
                                  [ngModelOptions]="{ standalone: true }"
                                  [readonly]="locked"
                                  data-test-id="fat-pruefung-number-input" />
                              </div>
                            </div>
                          </div>
                        }
                        @if (reflectData.fieldType === 'date') {
                          <div class="objektTyp3">
                            <div class="comboboxcontainer clr-form-control clr-row">
                              @if (reflectData.subheading) {
                                <label class="clr-col-md-4 clr-control-label" id="subheading">
                                  {{ reflectData.subheading }}
                                </label>
                              }
                              @if (!locked) {
                                <div class="clr-date-container clr-col-md-8">
                                  <input
                                    type="date"
                                    style="width: 265px"
                                    id="date"
                                    clrDate
                                    [ngModel]="reflectData.value | localeDate"
                                    (ngModelChange)="reflectData.value = localeDate.tosql($event)"
                                    [ngModelOptions]="{ standalone: true, updateOn: 'blur' }"
                                    data-test-id="fat-pruefung-date-input" />
                                </div>
                              } @else {
                                <div class="clr-date-container clr-col-md-8">
                                  <input
                                    clrInput
                                    style="width: 300px"
                                    type="text"
                                    [ngModel]="reflectData.value"
                                    [ngModelOptions]="{ standalone: true }"
                                    readonly />
                                </div>
                              }
                            </div>
                          </div>
                        }
                        @if (reflectData.fieldType === 'checkbox') {
                          <div class="objektTypCheckbox">
                            <div class="comboboxcontainer clr-form-control clr-row">
                              @if (reflectData.subheading) {
                                <label class="clr-col-md-4 clr-control-label" id="subheading">
                                  {{ reflectData.subheading }}
                                </label>
                              }
                              <div class="clr-control-container clr-col-md-8">
                                <clr-checkbox-container>
                                  <clr-checkbox-wrapper>
                                    <input
                                      type="checkbox"
                                      clrCheckbox
                                      [(ngModel)]="reflectData.value"
                                      class="cb"
                                      [readonly]="locked"
                                      data-test-id="fat-pruefung-checkbox-input" />
                                  </clr-checkbox-wrapper>
                                </clr-checkbox-container>
                              </div>
                            </div>
                          </div>
                        }
                      }
                    }
                    <br />
                    <br />
                    <br />
                    <br />
                  </form>
                }
              </div>
              <div class="clr-col-2">
                <br />
                <br />
                <div>
                  @if (os === 'Windows') {
                    <button
                      class="btn"
                      type="button"
                      (click)="openCamera(undefined)"
                      data-test-id="fat-pruefung-foto-button">
                      <cds-icon shape="camera" />
                      {{ 'Foto' | mrTranslate }}
                    </button>
                  } @else {
                    <button
                      class="btn"
                      type="button"
                      (click)="fileInput.click()"
                      data-test-id="fat-pruefung-foto-button">
                      <cds-icon shape="image-gallery" />
                      {{ 'Foto' | mrTranslate }}
                    </button>
                    <input
                      type="file"
                      #fileInput
                      id="fileInput"
                      accept="image/*"
                      capture="camera"
                      name="fileInput"
                      style="display: none"
                      multiple
                      (change)="onFileChange($event)"
                      data-test-id="fat-pruefung-file-input" />
                  }
                </div>
                @if (previewThumbnails.length > 0) {
                  <div
                    class="clr-row previewThumbnailsContainer"
                    data-test-id="fat-pruefung-main-preview"
                    [style.justify-content]="'space-evenly'">
                    @for (thumb of previewThumbnails; track thumb) {
                      <div class="uploadImagePreviewContainer">
                        <a
                          class="deletePreview"
                          href="javascript:void(0);"
                          (click)="previewThumbnails.splice(previewThumbnails.indexOf(thumb), 1)">
                          <cds-icon shape="times-circle" solid="true" />
                        </a>
                        <a class="deletePreview1" href="javascript:void(0);" (click)="showPreviewImage(thumb)">
                          <cds-icon shape="search" />
                        </a>
                        <img [src]="thumb.src" alt="" class="uploadImagePreview" />
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
          <!-- <div class="content-container">
                      <div id="content-area" class="content-area">
                        <app-webcammodal [modalOpen]="iswebcam" (modalOpenChange)="iswebcam = $event"></app-webcammodal>
                      </div>
                    </div> -->
        </clr-tab-content>
      </clr-tab>

      @for (tab of clrtab; track tab; let i = $index) {
        <clr-tab>
          <button
            clrTabLink
            [clrTabLinkInOverflow]="i > 2"
            (click)="tabChange()"
            [attr.data-test-id]="'fat-pruefung-tab-' + i">
            {{ tab.titel | titlecase }}
          </button>
          <clr-tab-content *clrIfActive>
            <div id="formularerstellungsWrapper" class="fat-scroll-container">
              <div class="clr-row">
                <div class="clr-col-2"></div>
                <div class="clr-col-8">
                  <!-- <h3 id="title">{{ 'valeurs mesurées de intermediate' | mrTranslate }}:</h3> -->
                  <div>
                    <clr-accordion [clrAccordionMultiPanel]="true">
                      @for (item of tab.items; track item) {
                        <clr-accordion-panel (clrAccordionPanelOpenChange)="panelChange($event, item)">
                          <clr-accordion-title
                            data-test-id="fat-pruefung-accordion-item"
                            [attr.data-szaehnid]="item.szaehnid"
                            [attr.data-title]="item.title"
                            [attr.data-sourcetype]="item.SourceType">
                            @if (item.iscompleted === true) {
                              <cds-icon shape="success-standard" [ngStyle]="{ color: 'green' }"></cds-icon>
                              &nbsp;
                            }
                            <label>
                              {{ item.title }}
                              @if (item.hasfaults === true) {
                                &nbsp;
                                <cds-icon shape="error-standard" [ngStyle]="{ color: 'red' }" />
                              }
                            </label>
                          </clr-accordion-title>
                          <clr-accordion-content>
                            @if (item.SourceType === 0) {
                              @if (item.hasHelper) {
                                <button
                                  class="btn btn-sm"
                                  data-test-id="fat-pruefung-hilfe-button"
                                  (click)="openedHelperId.set(item.szaehnid); isHelperModalOpen.set(true)">
                                  <cds-icon shape="help-info" />
                                </button>
                              }
                              <span>{{ item.bemerkung }}</span>
                              <clr-datagrid
                                style="padding-top: 0px"
                                class="datagrid-compact"
                                [clrDgSelectionType]="'single'"
                                [clrDgSelected]="[selectedmessrow]"
                                (clrDgSelectedChange)="selectedmessrow = $event[0]; selectionmMessrowChanged($event[0])"
                                data-test-id="fat-pruefung-messen-grid">
                                @for (column of item.tableData.columns; track column) {
                                  <clr-dg-column [clrDgField]="column.id">
                                    <ng-container
                                      *clrDgHideableColumn="{
                                        hidden: column.id | hideIDColumns: ['i_sort', 'szaehnid', 'zart', 'code'],
                                      }">
                                      {{ column.id | mrTranslate | titlecase }}
                                    </ng-container>
                                  </clr-dg-column>
                                }
                                <clr-dg-column>{{ 'Wert' | mrTranslate }}</clr-dg-column>
                                <clr-dg-column>{{ 'Fehler' | mrTranslate }}</clr-dg-column>
                                <clr-dg-column>{{ 'Bemerkung' | mrTranslate }}</clr-dg-column>
                                <clr-dg-row
                                  *clrDgItems="let row of item.tableData.rows"
                                  [clrDgItem]="row"
                                  [attr.data-szaehnid]="item.szaehnid"
                                  [attr.data-code]="row.Code || row.code">
                                  <clr-dg-action-overflow>
                                    @if (os === 'Windows') {
                                      <button
                                        class="action-item"
                                        (click)="openCamera(row)"
                                        data-test-id="fat-pruefung-messwert-foto">
                                        {{ 'Foto' | mrTranslate }}
                                      </button>
                                    } @else {
                                      <button
                                        class="action-item"
                                        (click)="fileInput.click()"
                                        data-test-id="fat-pruefung-messwert-foto">
                                        {{ 'Foto' | mrTranslate }}
                                      </button>
                                      <input
                                        type="file"
                                        #fileInput
                                        id="fileInput"
                                        accept=".jpg"
                                        capture="camera"
                                        name="fileInput"
                                        style="display: none"
                                        (change)="onMessFileChange($event, row)"
                                        data-test-id="fat-pruefung-messwert-file-input" />
                                    }
                                    <button
                                      class="action-item"
                                      (click)="openBem(row)"
                                      data-test-id="fat-pruefung-messwert-bemerkung">
                                      {{ 'Bemerkung' | mrTranslate }}
                                    </button>
                                  </clr-dg-action-overflow>
                                  @for (cell of item.tableData.columns; track cell) {
                                    <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                                  }
                                  <clr-dg-cell>
                                    <input
                                      clrInput
                                      style="width: 80px"
                                      type="number"
                                      [(ngModel)]="row.istValue"
                                      (blur)="validateRow(row, item)"
                                      data-test-id="fat-pruefung-messwert-input" />
                                  </clr-dg-cell>
                                  <clr-dg-cell>
                                    @if (row.ausfallValue !== null && row.ausfallValue !== undefined) {
                                      <cds-icon
                                        shape="error-standard"
                                        size="22"
                                        solid="true"
                                        [ngStyle]="{ color: 'red' }" />
                                    }
                                    <!-- {{ row.ausfallValue }} -->
                                  </clr-dg-cell>
                                  <clr-dg-cell>
                                    @if (row.bemerkung) {
                                      <cds-icon
                                        shape="info-circle"
                                        size="24"
                                        class="is-info cursor-pointer"
                                        (click)="openBem(row)"
                                        data-test-id="fat-pruefung-messen-bemerkung-icon" />
                                    }
                                  </clr-dg-cell>
                                </clr-dg-row>
                                <clr-dg-footer>
                                  {{ item.tableData.rows.length }} {{ 'Zeilen' | mrTranslate }}
                                </clr-dg-footer>
                              </clr-datagrid>
                            } @else {
                              <form clrForm class="clr-form clr-form-horizontal">
                                <div class="clr-row">
                                  <!-- <div class="clr-col-2">
                                        </div> -->
                                  <div class="clr-col-10">
                                    <table class="table table-noborder table-compact clr-thead-bgcolor">
                                      <thead>
                                        <tr>
                                          <th class="left">
                                            <label>{{ 'Kontrolle' | mrTranslate }}</label>
                                          </th>
                                          <th colspan="2">
                                            <label>{{ 'Zustand' | mrTranslate }}</label>
                                          </th>
                                          <th></th>
                                          <th></th>
                                          <th></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        @for (cell of item.tableData.rows; track cell; let ri = $index) {
                                          <tr>
                                            <td class="left">{{ cell.Bezeichnung }}</td>
                                            <td>
                                              <clr-radio-wrapper>
                                                <input
                                                  type="radio"
                                                  clrRadio
                                                  [name]="'vis_' + item.szaehnid + '_' + ri"
                                                  [(ngModel)]="cell.istValue"
                                                  [ngModelOptions]="{ standalone: true }"
                                                  value="0"
                                                  (change)="handleChange(0, cell, item)"
                                                  (click)="handleChange(0, cell, item)"
                                                  data-test-id="fat-pruefung-radio-accepted" />
                                                <label>{{ 'Accepted' | mrTranslate }}</label>
                                              </clr-radio-wrapper>
                                            </td>
                                            <td>
                                              <clr-radio-wrapper>
                                                <input
                                                  type="radio"
                                                  clrRadio
                                                  [name]="'vis_' + item.szaehnid + '_' + ri"
                                                  [(ngModel)]="cell.istValue"
                                                  [ngModelOptions]="{ standalone: true }"
                                                  value="1"
                                                  (change)="handleChange(1, cell, item)"
                                                  (click)="handleChange(1, cell, item)"
                                                  data-test-id="fat-pruefung-radio-not-accepted" />
                                                <label>{{ 'Not Accepted' | mrTranslate }}</label>
                                              </clr-radio-wrapper>
                                            </td>
                                            <td>
                                              @if (os === 'Windows') {
                                                <button
                                                  [disabled]="!(cell.istValue === '1' || cell.istValue === '0')"
                                                  type="button"
                                                  class="btn btn-sm"
                                                  (click)="openCamera(cell)"
                                                  data-test-id="fat-pruefung-visuell-foto">
                                                  {{ 'Foto' | mrTranslate }}
                                                </button>
                                              } @else {
                                                <button
                                                  [disabled]="!(cell.istValue === '1' || cell.istValue === '0')"
                                                  type="button"
                                                  class="btn btn-sm"
                                                  (click)="fileInput.click()"
                                                  data-test-id="fat-pruefung-visuell-foto">
                                                  {{ 'Foto' | mrTranslate }}
                                                </button>
                                              }
                                            </td>
                                            <td>
                                              <button
                                                [disabled]="!(cell.istValue === '1' || cell.istValue === '0')"
                                                type="button"
                                                class="btn btn-sm"
                                                (click)="openBem(cell)"
                                                data-test-id="fat-pruefung-visuell-bemerkung">
                                                {{ 'Bemerkung' | mrTranslate }}
                                              </button>
                                            </td>
                                            <td>
                                              @if (cell.bemerkung) {
                                                <cds-icon
                                                  shape="info-circle"
                                                  size="24"
                                                  class="is-info cursor-pointer"
                                                  (click)="openBem(cell)"
                                                  data-test-id="fat-pruefung-visuell-bemerkung-icon" />
                                              }
                                            </td>
                                          </tr>
                                          <input
                                            type="file"
                                            #fileInput
                                            id="fileInput"
                                            accept=".jpg"
                                            capture="camera"
                                            name="fileInput"
                                            style="display: none"
                                            (change)="onMessFileChange($event, cell)" />
                                        }
                                      </tbody>
                                    </table>
                                  </div>
                                  <div class="clr-col-2">
                                    @if (previewMessThumbnails.length > 0) {
                                      <div
                                        style="margin-top: 47px"
                                        class="clr-row previewThumbnailsContainer"
                                        data-test-id="fat-pruefung-mess-preview"
                                        [style.justify-content]="'space-evenly'">
                                        @for (thumb of previewMessThumbnails; track thumb) {
                                          <div class="uploadImagePreviewContainer">
                                            <a
                                              class="deletePreview"
                                              href="javascript:void(0);"
                                              (click)="
                                                previewMessThumbnails.splice(previewMessThumbnails.indexOf(thumb), 1)
                                              ">
                                              <cds-icon shape="times-circle" solid="true" />
                                            </a>
                                            <a
                                              class="deletePreview1"
                                              href="javascript:void(0);"
                                              (click)="showPreviewImage(thumb)">
                                              <cds-icon shape="search" />
                                            </a>
                                            <img [src]="thumb.src" alt="" class="uploadImagePreview" />
                                          </div>
                                        }
                                      </div>
                                    }
                                  </div>
                                </div>
                              </form>
                            }
                            <!-- <div class="limit-height-500"> -->
                            <!-- </div> -->
                            @if (item.image != null) {
                              <div class="clr-row" style="min-height: 180px; max-height: 180px; text-align: center">
                                <img [src]="item.image" alt="" style="max-height: 178px" class="uploadImagePreview" />
                              </div>
                            }
                            <app-preview-thumbnails [data]="item.images" [readonly]="true"></app-preview-thumbnails>
                            <br />
                          </clr-accordion-content>
                        </clr-accordion-panel>
                      }
                    </clr-accordion>
                  </div>
                  <br />
                  <br />
                  <br />
                  <br />
                </div>
                <div class="clr-col-2">
                  @if (previewMessThumbnails.length > 0) {
                    <div
                      style="margin-top: 47px"
                      class="clr-row previewThumbnailsContainer"
                      data-test-id="fat-pruefung-mess-preview"
                      [style.justify-content]="'space-evenly'">
                      @for (thumb of previewMessThumbnails; track thumb) {
                        <div class="uploadImagePreviewContainer">
                          <a
                            class="deletePreview"
                            href="javascript:void(0);"
                            (click)="previewMessThumbnails.splice(previewMessThumbnails.indexOf(thumb), 1)">
                            <cds-icon shape="times-circle" solid="true" />
                          </a>
                          <a class="deletePreview1" href="javascript:void(0);" (click)="showPreviewImage(thumb)">
                            <cds-icon shape="search" />
                          </a>
                          <img [src]="thumb.src" alt="" class="uploadImagePreview" />
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </clr-tab-content>
        </clr-tab>
      }

      <clr-tab>
        <button
          clrTabLink
          [clrTabLinkInOverflow]="clrtab.length > 3"
          (click)="tabChange()"
          [title]="'Unterschrift' | mrTranslate"
          data-test-id="fat-pruefung-tab-signature">
          {{ 'Unterschrift' | mrTranslate | titlecase }}
        </button>
        <clr-tab-content *clrIfActive>
          <div class="clr-row">
            <div class="clr-col-12 clr-col-lg-6">
              <form clrForm [formGroup]="resultForm" class="clr-form clr-form-horizontal">
                <div class="comboboxcontainer clr-form-control clr-row">
                  <label class="clr-col-md-4 clr-control-label">{{ 'Datum' | mrTranslate }}</label>
                  <div class="clr-control-container clr-col-md-8">
                    <input
                      type="date"
                      style="width: 265px"
                      id="date"
                      clrDate
                      data-test-id="fat-pruefung-signatur-datum"
                      [ngModel]="resultForm.get('datum').value | localeDate"
                      (ngModelChange)="resultForm.get('datum').setValue(localeDate.tosql($event))"
                      [ngModelOptions]="{ standalone: true, updateOn: 'blur' }" />
                  </div>
                </div>

                <div class="comboboxcontainer clr-form-control clr-row">
                  <label class="clr-col-md-4 clr-control-label">{{ 'Ort' | mrTranslate }}</label>
                  <div class="clr-control-container clr-col-md-8">
                    <input
                      clrInput
                      style="width: 300px"
                      type="text"
                      formControlName="ort"
                      data-test-id="fat-pruefung-signatur-ort" />
                  </div>
                </div>

                <div class="comboboxcontainer clr-form-control clr-row">
                  <label class="clr-col-md-4 clr-control-label">{{ 'Prüfer' | mrTranslate }}</label>
                  <div class="clr-control-container clr-col-md-8">
                    <input
                      clrInput
                      style="width: 300px"
                      type="text"
                      formControlName="pruefername"
                      data-test-id="fat-pruefung-signatur-pruefer" />
                  </div>
                </div>

                <div class="clr-form-control clr-row fileUpload">
                  <label class="clr-col-md-4 clr-control-label">{{ 'Unterschrift Prüfer' | mrTranslate }}</label>
                  <div class="clr-control-container clr-col-md-8">
                    <button
                      type="button"
                      class="btn btn-icon"
                      aria-label="home"
                      (click)="addSignatur('pruefer')"
                      data-test-id="fat-pruefung-signatur-add-pruefer">
                      <cds-icon shape="signatur" />
                    </button>
                  </div>
                </div>

                @if (pruefersignatur.length > 0) {
                  <div class="clr-row">
                    <div class="clr-col-4"></div>
                    <div class="clr-col-5">
                      <div class="clr-row previewThumbnailsContainer" [style.justify-content]="'space-evenly'">
                        @for (thumb of pruefersignatur; track thumb) {
                          <div class="uploadImagePreviewContainer">
                            <a
                              class="deletePreview"
                              href="javascript:void(0);"
                              (click)="pruefersignatur.splice(pruefersignatur.indexOf(thumb), 1)">
                              <cds-icon shape="times-circle" solid="true" />
                            </a>
                            <a class="deletePreview1" href="javascript:void(0);" (click)="showPreviewImage(thumb)">
                              <cds-icon shape="search" />
                            </a>
                            <img [src]="thumb.src" alt="" class="uploadImagePreview" />
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }

                <div class="comboboxcontainer clr-form-control clr-row">
                  <label class="clr-col-md-4 clr-control-label">{{ 'Kunde' | mrTranslate }}</label>
                  <div class="clr-control-container clr-col-md-8">
                    <input
                      clrInput
                      style="width: 300px"
                      type="text"
                      formControlName="kundename"
                      data-test-id="fat-pruefung-signatur-kunde" />
                  </div>
                </div>

                <div class="clr-form-control clr-row fileUpload">
                  <label
                    class="clr-col-md-4 clr-control-label"
                    style="font-size: 0.65rem; font-weight: var(--clr-forms-label-font-weight, 600)">
                    {{ 'Unterschrift Kunde' | mrTranslate }}
                  </label>
                  <div class="clr-col-md-8" style="display: flex; justify-content: flex-start; align-items: center">
                    <button
                      type="button"
                      class="btn btn-icon"
                      aria-label="home"
                      (click)="addSignatur('kunde')"
                      data-test-id="fat-pruefung-signatur-add-kunde">
                      <cds-icon shape="signatur" />
                    </button>
                  </div>
                </div>

                @if (kundesignatur.length > 0) {
                  <div class="clr-row">
                    <div class="clr-col-4"></div>
                    <div class="clr-col-5">
                      <div class="clr-row previewThumbnailsContainer" [style.justify-content]="'space-evenly'">
                        @for (thumb of kundesignatur; track thumb) {
                          <div class="uploadImagePreviewContainer">
                            <a
                              class="deletePreview"
                              href="javascript:void(0);"
                              (click)="kundesignatur.splice(kundesignatur.indexOf(thumb), 1)">
                              <cds-icon shape="times-circle" solid="true" />
                            </a>
                            <a class="deletePreview1" href="javascript:void(0);" (click)="showPreviewImage(thumb)">
                              <cds-icon shape="search" />
                            </a>
                            <img [src]="thumb.src" alt="" class="uploadImagePreview" />
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }

                <div class="comboboxcontainer clr-form-control clr-row">
                  <label class="clr-col-md-4 clr-control-label">{{ 'Bemerkung' | mrTranslate }}</label>
                  <div class="clr-control-container clr-col-md-8">
                    <clr-textarea-container>
                      <textarea
                        style="width: 300px; margin-left: 85px"
                        rows="8"
                        clrTextarea
                        formControlName="bemerkung"
                        name="description"></textarea>
                    </clr-textarea-container>
                  </div>
                </div>
                <br />
                <br />
                <br />
              </form>
            </div>
          </div>
        </clr-tab-content>
      </clr-tab>
    </clr-tabs>
  </div>
</div>

<app-hilfe-beschreibung-modal
  [(isModalOpen)]="isHelperModalOpen"
  [table]="'SZAEHN'"
  [id]="openedHelperId()"
  [readonly]="true" />

<clr-modal
  [(clrModalOpen)]="showsignaturpad"
  [clrModalClosable]="true"
  [clrModalSize]="'lg'"
  data-test-id="fat-pruefung-signatur-modal">
  <h3 class="modal-title">{{ modaltitel | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm>
      <canvas #canvas width="780" height="430" data-test-id="fat-pruefung-signatur-canvas"></canvas>
    </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-primary"
      (click)="updatesignatur()"
      data-test-id="fat-pruefung-signatur-uebernehmen">
      {{ 'Übernehmen' | mrTranslate }}
    </button>
    <button type="button" class="btn" (click)="deletesignatur()" data-test-id="fat-pruefung-signatur-loeschen">
      {{ 'Löschen' | mrTranslate }}
    </button>
    <button type="button" class="btn" (click)="showsignaturpad = false" data-test-id="fat-pruefung-signatur-beenden">
      {{ 'Beenden' | mrTranslate }}
    </button>
  </div>
</clr-modal>

<clr-modal [(clrModalOpen)]="openModalBem" [clrModalClosable]="true">
  <h3 class="modal-title">{{ 'Bemerkung' | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm style="width: 100%; height: 100%">
      <textarea
        clrTextarea
        rows="8"
        style="margin-top: -15px; width: 100%; height: 100%"
        #rowBem
        name="description"></textarea>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="setBem()">{{ 'OK' | mrTranslate }}</button>
    <button type="button" class="btn" (click)="openModalBem = false">{{ 'Abbrechen' | mrTranslate }}</button>
  </div>
</clr-modal>
